import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RouteTrackerService } from 'src/app/services/route-tracker.service';
import { openBalanceRecharge } from '../../balance-recharge-selection/balance-recharge-selection.component';
import { UserPaymentMethods, UserAdministratedBalances, BalanceRechargeSelectionData, BalanceBenefitType } from 'src/app/interfaces';
import { removeUnavailableEdenredMethods } from 'src/app/services/edenred-availability';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-secondary-toolbar',
  templateUrl: './secondary-toolbar.component.html',
  styleUrls: ['./secondary-toolbar.component.scss']
})
export class SecondaryToolbarComponent {
  @Input() title: string;
  @Input() storeId?: string;
  @Input() backRoute?: string;
  @Input() keepQueryParams: boolean = false;
  @Input() useBrowserBack: boolean = false;
  @Input() isCatalog: boolean = false;
  @Input() balance: number = 0;
  @Input() benefitType: BalanceBenefitType = BalanceBenefitType.CURRENCY;
  @Input() userPaymentMethodsForStore?: UserPaymentMethods;

  constructor(
    private routeTrackerService: RouteTrackerService,
    private router: Router,
    private dialog: MatDialog,
    private analytics: AnalyticsService,
    private location: Location
  ) {}

  onGoBackClicked() {
    if (this.backRoute) {
      const queryParams = this.keepQueryParams ? this.router.routerState.snapshot.root.queryParams : {};
      this.router.navigate([this.backRoute], { queryParams });
    }
    else if (this.useBrowserBack) this.location.back();
    else if (this.isCatalog) this.router.navigateByUrl('/home');
    else this.routeTrackerService.goBack();
  }

  onBalancePressed() {
    const availableMethods = this.getAvailableRechargeMethods();

    if (availableMethods.length === 0) {
      return;
    }

    openBalanceRecharge(this.dialog, this.analytics, {
      availableMethods,
      origin: 'catalog',
      storeId: this.storeId
    } as BalanceRechargeSelectionData);
  }

  /**
   * Gets the list of available recharge methods based on user's balance for store
   * @returns Array of available rechargeable balance methods
   */
  getAvailableRechargeMethods(): UserAdministratedBalances[] {
    if (!this.userPaymentMethodsForStore?.balance) {
      return [];
    }

    const availableMethods: UserAdministratedBalances[] = [];
    const balanceKeys = Object.keys(this.userPaymentMethodsForStore.balance);

    balanceKeys.forEach(balanceId => {
      if (Object.values(UserAdministratedBalances).includes(balanceId as UserAdministratedBalances)) {
        availableMethods.push(balanceId as UserAdministratedBalances);
      }
    });

    return removeUnavailableEdenredMethods(availableMethods);
  }

  /**
   * Checks if the user's balance is rechargeable
   * @returns True if there are available recharge methods
   */
  isMixBenefitType(): boolean {
    return this.benefitType === BalanceBenefitType.MIX;
  }

  isPointsBenefitType(): boolean {
    return this.benefitType === BalanceBenefitType.POINTS;
  }

  isBalanceRechargable(): boolean {
    return this.getAvailableRechargeMethods().length > 0;
  }
}
